import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Btn from '../components/ui/Btn';
import { Input } from '../components/ui/Input';
import { useAuth } from '../context/AuthContext';
import { COLORS, FONT } from '../theme';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState('');
  const [enviando, setEnviando] = useState(false);

  const enviar = async (e) => {
    e.preventDefault();
    setEnviando(true);
    setErro('');
    try {
      await login(email, senha);
      navigate('/produtos');
    } catch (err) {
      setErro(err.message);
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div style={{ height: '100vh', overflow: 'hidden', display: 'flex', fontFamily: FONT }}>
      <div style={{
        width: '48%', minWidth: 420, display: 'flex', flexDirection: 'column', justifyContent: 'center',
        padding: '0 64px', position: 'relative', overflow: 'hidden',
        background: `linear-gradient(145deg, ${COLORS.primaryDark} 0%, ${COLORS.primary} 55%, ${COLORS.accent} 100%)`,
        color: '#fff'
      }}
      className="coren-login-hero"
      >
        <div style={{ position: 'absolute', width: 340, height: 340, borderRadius: '50%', background: 'rgba(255,255,255,0.08)', top: -100, right: -100, pointerEvents: 'none' }} />
        <div style={{ position: 'absolute', width: 220, height: 220, borderRadius: '50%', background: 'rgba(255,255,255,0.06)', bottom: -60, left: -60, pointerEvents: 'none' }} />

        <img src="/logo-coren-bc.png" alt="Coren" style={{ height: 40, objectFit: 'contain', marginBottom: 36 }} />
        <h1 style={{ fontSize: 30, fontWeight: 900, letterSpacing: '-0.03em', margin: 0, maxWidth: 380 }}>
          Gestão completa para distribuidoras e fábricas
        </h1>
        <p style={{ fontSize: 14, opacity: 0.9, marginTop: 14, maxWidth: 360, lineHeight: 1.6 }}>
          Produtos, estoque, fiscal e muito mais em um só lugar.
        </p>
      </div>

      <div style={{ flex: 1, background: '#ffffff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ width: '100%', maxWidth: 400, padding: '48px 56px' }}>
          <div style={{ fontSize: 11, fontWeight: 700, color: COLORS.primary, textTransform: 'uppercase', letterSpacing: '0.12em' }}>
            Coren ERP
          </div>
          <h2 style={{ fontSize: 24, fontWeight: 800, color: '#182e0e', letterSpacing: '-0.03em', margin: '8px 0 4px' }}>
            Entrar na plataforma
          </h2>
          <p style={{ fontSize: 13, color: COLORS.textMid, margin: '0 0 28px' }}>
            Acesse com seu email e senha.
          </p>

          <form onSubmit={enviar} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <Input label="Email" type="email" value={email} onChange={e => setEmail(e.target.value)} required autoFocus />
            <Input label="Senha" type="password" value={senha} onChange={e => setSenha(e.target.value)} required />

            {erro && (
              <div style={{ color: COLORS.danger, background: COLORS.dangerBg, border: '1px solid #FECACA', borderRadius: 8, padding: '9px 13px', fontSize: 13 }}>
                {erro}
              </div>
            )}

            <button
              type="submit"
              disabled={enviando}
              style={{
                width: '100%', padding: '14px 18px', border: 'none', borderRadius: 14,
                background: enviando ? '#82a6f0' : `linear-gradient(135deg, ${COLORS.primaryDark} 0%, ${COLORS.primary} 100%)`,
                color: '#fff', fontSize: 15, fontWeight: 700, cursor: enviando ? 'default' : 'pointer',
                boxShadow: '0 4px 20px rgba(29,107,240,0.35)', fontFamily: FONT
              }}
            >
              {enviando ? 'Entrando...' : 'Entrar'}
            </button>
          </form>

          <p style={{ fontSize: 11, color: '#B0BEC5', textAlign: 'center', marginTop: 36 }}>
            Coren · Gestão Completa
          </p>
        </div>
      </div>

      <style>{`
        @media (max-width: 700px) {
          .coren-login-hero { display: none !important; }
        }
      `}</style>
    </div>
  );
}
